import Drawer from '@/component/Drawer'
import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector, PopUpStore } from '@/store/PopupStore'
import React from 'react'
import { useTranslation } from 'react-i18next'
import LoginMain from './LoginMain'

const LoginPopup: React.FC<PropType> = () => {
  const { t } = useTranslation('uc')
  const loginPopupVisible = useStatePopup(PopupSelector.loginPopupVisible)

  const handleClose = () => {
    PopUpStore.setLoginPopupVisible(false)
  }

  return (
    <Drawer
      visible={loginPopupVisible}
      zIndex={903}
      onClose={handleClose}
      lockScroll={true}
      destroyOnClose
      className="bg-primary-light"
      title={t('modalTitle.login')}
    >
      <div className="h-full px-md">
        <LoginMain />
      </div>
    </Drawer>
  )
}

interface PropType {}

export default LoginPopup
